// Third party libraries
import { Button, Icon } from "semantic-ui-react";
import { useEffect, useState } from "react";

// Models
import SecurityModel from '../../../../models/security';

// Locales
import I18n from "../../../../i18n";

// Styles
import './affiliationRequestsButton.css'

type Props = {
    onOpen: () => void
}

function AffiliationRequestsButton({ onOpen }: Props) {

    const [showNotify, setShowNotify] = useState(true);

    useEffect(()=>{

        SecurityModel.getUserProAffiliationRequests().then( requests => {

            const pendingRequests = requests.some(request => request.status === 'pending');

            setShowNotify(pendingRequests);

        } ).catch(error => {

            console.error(error);

        })

    }, [])

  return (
    <Button className="affiliationRequestsButton" onClick={ onOpen }>
        <span>{ I18n.t('students.affiliationRequest.title') }</span>
        {
            showNotify && <Icon className="affiliationNotify" name="circle thin" color="blue" />
        }
    </Button>
  )
}

export default AffiliationRequestsButton;